import React from 'react';
import { Box, Text } from '@common-fe/common-fe';

interface Props {
  title: string;
  desc: string;
}

const FraudThresholdFieldLabel: React.FC<Props> = ({ title, desc }) => (
  <Box flex={{ grow: 1 }}>
    <Text margin={{ bottom: 'spacing4' }} weight="bold" color="textBody">
      {title}
    </Text>
    <Box width={{ max: '360px' }}>
      <Text weight={500} size="small" color="textSecondary">
        {desc}
      </Text>
    </Box>
  </Box>
);

export default FraudThresholdFieldLabel;
